import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { CreditIncreaseService } from './credit-increase.service';
import { Injectable } from '@angular/core';
@Injectable()
export class serviceInterceptor implements HttpInterceptor {
  constructor(private loader: CreditIncreaseService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loader.show();

    return next.handle(req).pipe(
      tap(
        (req) => {
          if (req instanceof HttpResponse) {
            this.loader.hide();
          }
        },
        (err) => {
          this.loader.hide();
        }
      )
    );
  }

  
}
